import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VenueInfo = ({ venue }) => {
  const handleDirections = () => {
    const address = encodeURIComponent(`${venue?.address}, ${venue?.city}, ${venue?.state} ${venue?.zipCode}`);
    window.open(`https://maps.google.com/maps?q=${address}`, '_blank');
  };

  return (
    <div className="bg-card rounded-lg p-6 mb-8">
      <h2 className="text-2xl font-semibold text-foreground mb-6">Venue Information</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Venue Details */}
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium text-foreground mb-2">{venue?.name}</h3>
            <div className="space-y-2 text-muted-foreground">
              <div className="flex items-start gap-2">
                <Icon name="MapPin" size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <p>{venue?.address}</p>
                  <p>{venue?.city}, {venue?.state} {venue?.zipCode}</p>
                </div>
              </div>
              
              {venue?.phone && (
                <div className="flex items-center gap-2">
                  <Icon name="Phone" size={16} />
                  <p>{venue?.phone}</p>
                </div>
              )}
              
              {venue?.website && (
                <div className="flex items-center gap-2">
                  <Icon name="Globe" size={16} />
                  <a 
                    href={venue?.website} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Visit Website
                  </a>
                </div>
              )}
            </div>
          </div>
          
          {/* Venue Features */}
          {venue?.features && venue?.features?.length > 0 && (
            <div>
              <h4 className="font-medium text-foreground mb-2">Venue Features</h4>
              <div className="grid grid-cols-2 gap-2">
                {venue?.features?.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Check" size={14} className="text-success" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* Parking Info */}
          {venue?.parking && (
            <div>
              <h4 className="font-medium text-foreground mb-2">Parking Information</h4>
              <p className="text-sm text-muted-foreground">{venue?.parking}</p>
            </div>
          )}
          
          <Button
            variant="outline"
            onClick={handleDirections}
            iconName="Navigation"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Get Directions
          </Button>
        </div>
        
        {/* Map */}
        <div className="h-64 lg:h-80 rounded-lg overflow-hidden bg-muted">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={venue?.name}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${venue?.latitude},${venue?.longitude}&z=15&output=embed`}
            className="border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default VenueInfo;